import { render, staticRenderFns } from "./card-briefing-client.vue?vue&type=template&id=af1dee16&"
import script from "./card-briefing-client.vue?vue&type=script&lang=js&"
export * from "./card-briefing-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports